/*
 * @Author: Betway huangbo@mrcdevlab.com
 * @Date: 2025-03-12 16:16:20
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2025-03-13 13:08:54
 * @FilePath: \mrc-ess-base-frontend\src\utils\awss3.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import AWS from 'aws-sdk'
import ls from '@/utils/Ls';
const awsConfig = {
    save: (config) => {
       if (config) ls.set('application-aws-config',JSON.stringify({...config}))
    },
    get: (param = undefined) => {
       let _config = ls.get('application-aws-config')
       if (!_config) return ''
       var config = JSON.parse(_config)
       return param ? config[param] || '' : config
    },
    getKey: (path) => {
       let config = awsConfig.get()
       if (!config) return path
       if (path.indexOf('?') > -1) path = path.split('?')[0]
       return path.replace(`${config['endpoint']}/${config['bucket']}/`, '')
    }
 }
 const awss3 = {
    _init: (option = {}) => {
       if (!option) return
       const config = Object.assign({ ...option })
       awsConfig.save(config)
       AWS.config.update({
          endpoint: config['endpoint'],
          accessKeyId: config['accessKeyId'],
          secretAccessKey: config['secretAccessKey'],
          region: config['region'],
          s3ForcePathStyle: true,
          signatureVersion:'v4'
       })
    },
    upload: (file, key) => {
       return new Promise((reslove, reject) => {
          awss3._init(awsConfig.get())
          const s3 = new AWS.S3()
          const _opt = {
             Bucket: awsConfig.get('bucket'), //bucket-name
             Key: `${awsConfig.getKey(key)}` //唯一key，存儲位置
          }
          const params = {
             ..._opt,
             Body: file, // 文件对象
             ContentType: file.type // 文件类型，例如 'image/jpeg'
          }
          s3.upload(params, (err, data) => {
             if (err) {
                reject(err)
             } else {
                reslove({ ...data, url: awss3.sign(_opt.Key) })
             }
          })
       })
    },
    delete: (paths = []) => {
       return new Promise((reslove, reject) => {
          awss3._init(awsConfig.get())
          const s3 = new AWS.S3()
          const params = {
             Bucket: awsConfig.get('bucket'),
             Delete: {
                Objects: paths.map((e) => awsConfig.getKey(e))
             }
          }
          s3.deleteObjects(params, (err, data) => {
             if (err) {
                reject(err)
             } else {
                reslove(data)
             }
          })
       })
    },
    sign: (path) => {
       awss3._init(awsConfig.get())
       const s3 = new AWS.S3()
       try {
          let url = s3.getSignedUrl('getObject', { Bucket: awsConfig.get('bucket'), Key: awsConfig.getKey(path), Expires: awsConfig.get('expires')||60 * 60 * 24 })
          return url
       } catch (error) {
          console.error(error)
          return path
       }
    }
}
export default awss3
